import React from 'react';
import UseInvalidTokenModal from '../../hooks/useInvalidTokenModal';
import useAuth from '../../hooks/authentication/useAuth';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContentText,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

const InvalidTokenModal: React.FC<{ open: boolean }> = (props) => {
    const invalidTokenModal = UseInvalidTokenModal();
    const auth = useAuth();
    const { t } = useTranslation('translation', {
        keyPrefix: 'INVALID_TOKEN_MODAL',
    });

    const handleClose = () => {
        invalidTokenModal.showModal(false);
        auth.logout();
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>{t('TITLE')}</StyledDialogTitle>
            <StyledDialogContent>
                <DialogContentText>{t('CONTENT')}</DialogContentText>
            </StyledDialogContent>
            <DialogActions>
                <Button
                    size="small"
                    onClick={handleClose}
                >
                    {t('BUTTON')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InvalidTokenModal;
